export default {
  inserted(el, binding, vnode) {
    // 默认头像 v-defaultAvatar="{path: '', sex: ''}"
    const path = binding.value.path;
    const sex = binding.value.sex;
    if (path) {
      el.src = window.g.BASE_API + path;
    } else if (sex == "1") {
      el.src = require("../../assets/images/man.png");
    } else if (sex == "2") {
      el.src = require("../../assets/images/girl.png");
    } else {
      console.log("系统错误！！！", path, sex);
    }
  }
};



// WEBPACK FOOTER //
// ./src/directive/permission/defaultAvatar.js